module.exports = __webpack_public_path__ + "img/manage-cancel-resume-icon.980dce04.svg";